import styled from "styled-components";
import {
  NewTypography,
  NewTextField,
  NewCheckBox,
  NewSelect,
  NewRadioGroup,
} from "@bca/ui-library";
import theme from "../../styles/theme";

export const StyledCompanyDetils = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 1.5rem;
`;

export const StyledTitle = styled(NewTypography)`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: ${(props) => (props.isMobile ? "22px" : "32px")};
  line-height: 29px;
  margin-top: 3.75rem;
`;

export const StyledTypography = styled(NewTypography)`
  display: flex;
  font-weight: normal;
`;

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.isMobile ? "1rem" : "3.5rem")};
`;

export const StyledInputGroup = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => (props.isMobile ? "2.5rem" : "2.8125rem")};
`;

export const StyledInput = styled(NewTextField)`
  width: 100%;
`;

export const StyledDisabledInput = styled(StyledInput)`
  input {
    background-color: #e4e6e8;
    border-radius: 10px;
    pointer-events: none;
  }
`;

export const StyledRadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${(props) => (props.isMobile ? "2rem" : "2.8125rem")} 0;
  row-gap: ${(props) => (props.isMobile ? "1.25rem" : "1.875rem")};
`;

export const StyledRadioGroup = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.isMobile ? "column" : "row")};
  flex-wrap: wrap;
  column-gap: 0.6875rem;
`;

export const StyledText = styled(NewTypography)`
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 22px;
  color: ${theme.color.radioLabel};
`;

export const StyledRadioLabel = styled(StyledText)`
  align-self: ${(props) => (props.isMobile ? null : "center")};
  min-width: ${(props) => (props.isMobile ? null : "28.3rem")};
  display: inline-block;
`;

export const StyledRequired = styled.span`
  color: ${theme.color.red};
  margin-left: 4px;
  margin-right: 4px;
`;

export const StyledCheckboxGroup = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${(props) => (props.isMobile ? "0.8125rem" : "0.5rem")};
  align-items: center;
`;

export const StyledCheckbox = styled(NewCheckBox)``;

export const StyledCheckboxLabel = styled(StyledText)`
  font-weight: 500;
  display: flex;
  flex-wrap: wrap;
`;

export const StyledHoverSpan = styled(StyledCheckboxLabel)`
  color: #0074e0;
  font-weight: 600;
  cursor: pointer;
`;

export const StyledDeliveryAddressGroup = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.5625rem;
`;

export const StyledPhoneNumberGroup = styled.div`
  width: 100%;
  display: flex;
  column-gap: 2.88rem;
`;

export const StyledNewSelect = styled(NewSelect)`
  width: 7.5rem;
  font-size: 3.28rem;
`;

export const StyledStateSelect = styled(NewSelect)``;

export const StyledRadioButtonGroup = styled(NewRadioGroup)`
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  column-gap: 1.875rem;
  & label {
    & span {
      font-style: normal;
      font-weight: 600 !important;
      font-size: 13px !important;
      line-height: 22px !important;
      color: #043074;
    }
  }
`;
